export interface ICashFlowFLI {
    id: string;
    fliDescription?: string;
    caption: string;
    fliType: string;
    fliCashFlow: number;
    currentValue: number | null;
    openingValue: number | null;
    previousValue: number | null;
    isCustom?: boolean;
}

export interface ICashFlowInvestingFLI extends ICashFlowFLI {
    investingPreviousValue: number | null;
    disinvestingPreviousValue: number | null;
    parentFli: string | null;
}
